//
// Mental Canvas web viewer.
// (c) 2016-2020 Mental Canvas Inc.
//
import {
    Quaternion,
    Vector3
} from 'three';
import {
    _Math,
    RBT
} from './utils';

export class Bookmark {
    constructor(quat: Quaternion, vec: Vector3, isInAnimation: boolean, lingerDuration: number, transitionDuration: number)
    {
        this.quat = quat.clone();
        this.vec = vec.clone();
        this.isInAnim = isInAnimation;
        this.linger = lingerDuration;
        this.transition = transitionDuration;
    }
    dispose() {
    }
    IsCenterOfRotationSet(): boolean {
        return this.centerOfRotation != null;
    }
    GetCenterOfRotation(): Vector3 {
        return this.centerOfRotation;
    }
    GetRBT() : RBT {
        return new RBT(this.quat, this.vec);
    }
    linger: number;
    transition: number;
    isInAnim: boolean;
    quat: Quaternion;
    vec: Vector3;

    aspect: number;
    // Set to zero if not specified
    stageId: number;
    centerOfRotation: Vector3;
    hiddenTileNames: string[];
};

